const scrollControlFunc = {
  // スクロール禁止
  noScroll: () => {
    document.addEventListener("wheel", scrollControlFunc.scrollControl, { passive: false });
    document.addEventListener("touchmove", scrollControlFunc.scrollControl, { passive: false });
  },
  // スクロール禁止解除
  returnScroll: () => {
    document.removeEventListener("wheel", scrollControlFunc.scrollControl, { passive: false });
    document.removeEventListener("touchmove", scrollControlFunc.scrollControl, { passive: false });
  },
  // スクロール禁止関数
  scrollControl: (event) => {
    event.preventDefault();
  }
}

export default scrollControlFunc;